import React from 'react'
import './Container.css'

const container = (props) => (
	<div className='Container'>
		{props.children}
	</div>
)

export default container